let isMaintenanceMode = false;

const listeners = new Set<() => void>();

/**
 * Framework-agnostic store for the global maintenance (503) flag.
 *
 * Lives outside React so the QueryCache/MutationCache `onError` handlers (which run in the
 * non-React queryClient module) can flip it, while Root subscribes to it via `useMaintenanceStore`.
 */
export const maintenanceStore = {
  getSnapshot: (): boolean => isMaintenanceMode,

  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  },

  setMaintenance: (value: boolean): void => {
    if (isMaintenanceMode === value) return;

    isMaintenanceMode = value;
    listeners.forEach((listener) => listener());
  },
};
